// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryList_root__1M4qd","item":"CategoryList_item__31pLn","link":"CategoryList_link__2Fh2t","active_link":"CategoryList_active_link__24vaB"};